"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetQueryRunResultsRpcResponseImplementation = exports.GetQueryRunResultsRpcRequestImplementation = void 0;
const core_1 = require("./core");
class GetQueryRunResultsRpcRequestImplementation extends core_1.BaseRpcRequest {
    constructor() {
        super(...arguments);
        this.method = "getQueryRunResults";
    }
}
exports.GetQueryRunResultsRpcRequestImplementation = GetQueryRunResultsRpcRequestImplementation;
class GetQueryRunResultsRpcResponseImplementation extends core_1.BaseRpcResponse {
}
exports.GetQueryRunResultsRpcResponseImplementation = GetQueryRunResultsRpcResponseImplementation;
//# sourceMappingURL=get-query-run-results.type.js.map